import { BackAppBar } from "@/components/ui";
import { isMpisAccount } from "@/libraries/helper";
import EmptyPeoples from "@/routes/dashboard/contacts/-components/EmptyPeoples";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import type React from "react";
import { Route } from "../";

const ForbiddenAccessMembers = ({
	title = "Invite Member",
}: { title?: string }) => {
	const navigate = Route.useNavigate();
	const { tab, subTab } = Route.useLoaderDeps({
		select: (s) => ({
			tab: s.tab,
			subTab: s.subTab,
		}),
	});
	const handleChangeTab = (e: React.SyntheticEvent, newValue: string) => {
		e.preventDefault();
		return navigate({
			search: {
				tab: newValue,
				subtab: newValue === "mpis" ? "contact" : undefined,
			},
			replace: true,
		});
	};
	const handleChangeSubTab = (e: React.SyntheticEvent, newValue: string) => {
		e.preventDefault();
		return navigate({
			search: {
				tab: tab,
				subtab: newValue,
			},
			replace: true,
		});
	};
	return (
		<>
			<BackAppBar title={title}>
				<div className="container pb-2 space-y-4">
					<Tabs
						centered
						value={tab}
						variant="fullWidth"
						textColor="inherit"
						aria-label="Contact Type"
						className="!rounded-full !bg-gray-light [&_.MuiTabs-indicator]:!bg-transparent !p-1"
						onChange={handleChangeTab}
					>
						<Tab
							value="contact"
							label="Contacts"
							classes={{
								selected: "!bg-white !rounded-full",
							}}
						/>
						<Tab
							value="directory"
							label="Directory"
							classes={{
								selected: "!bg-white !rounded-full",
							}}
						/>
						{isMpisAccount() ? (
							<Tab
								value="mpis"
								label="MPIS"
								classes={{
									selected: "!bg-white !rounded-full",
								}}
							/>
						) : null}
					</Tabs>
					{tab !== "mpis" ? (
						<Tabs
							value={subTab}
							variant="fullWidth"
							textColor="inherit"
							aria-label="Contact Sub Type"
							className="[&_.MuiTabs-indicator]:bg-primary"
							onChange={handleChangeSubTab}
						>
							<Tab
								value="team"
								label="Teams"
								style={{ textTransform: "none" }}
							/>
							<Tab
								value="contact"
								label="Contacts"
								style={{ textTransform: "none" }}
							/>
						</Tabs>
					) : null}
				</div>
			</BackAppBar>
			<div className="relative flex-1 bg-white overflow-y-auto">
				<EmptyPeoples
					title="Unlock the Professional Directory"
					message="Upgrade your plan to access verified and pro contacts in the directory. Expand your network today!"
					withButton={true}
					buttonLabel="Upgrade Now"
					buttonProps={{
						startIcon: <ArrowCircleUpIcon />,
						onClick: () =>
							navigate({
								to: "/subscription",
							}),
					}}
				/>
			</div>
		</>
	);
};

export default ForbiddenAccessMembers;
